export default __webpack_public_path__ + "static/media/formulario_dni_check.0a953171.svg";